
import React from 'react';
import commonUtil from '../../../../../../utils/commonUtil';

const GiftListConfigureWapModal = ({headerClassName, titleClassName , title , closeIconClassName, closeModal, bodyClassName , children , isHeader = true}) => {
  return (
    <div className="modal-overlay">
        <div className="modal-content-event modal-content-event-giftlist">
          {isHeader && <div className={headerClassName}  >
           <h4 className={titleClassName}  > {title}</h4>
           <button className={closeIconClassName} onClick={closeModal} aria-label="Cerrar modal">
            <img src={(commonUtil.getAssetURL() + '/images/close.svg')} alt="" className="icon_vozcliente" />            
          </button>
        </div>}
        <div className={bodyClassName}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default GiftListConfigureWapModal;